import React from "react"
import TwitterIcon from "../components/twitter-icon"
import { Link } from "gatsby"

const Footer = () => {
  return (
    <footer className="text-center bg-black text-white">
      <div className="text-sm">
        ポッポテニスメディアは、テニスを通じて人生がより豊かになったり、テニスを通じて全てが前向きになるようなそんな世界を目指します
      </div>
      <TwitterIcon />
      <div>
        <a
          href="https://forms.gle/Krop9vVJM94nbAk4A"
          target="_blank"
          rel="noopener noreferrer"
        >
          お問い合わせ
        </a>
      </div>
      <div className="flex justify-center">
        <Link to="/privacy">プライバシーポリシー</Link>
        <Link to="/term">利用規約</Link>
      </div>
      © {new Date().getFullYear()}, ポッポテニスメディア
    </footer>
  )
}

export default Footer
